import React from "react"; // ✅ makes it a module

interface BreadcrumbProps {
  name: string;
  country?: string;
  town?: string;
  profesional?: string[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  name,
  country = "Country",
  town = "Town",
  profesional = [],
}) => {
  return (
    <nav className="text-sm text-textGray px-4 lg:px-0 py-1 lg:pb-1 ">
      <ol className="flex flex-wrap items-center space-x-1">
        <li>
          <a href="/" className="hover:underline">
            Home
          </a>
          <span className="mx-1">·</span>
        </li>
        {profesional.length > 0 && (
          <>
            <li>
              <a href="#" className="hover:underline">
                {profesional[0]}
              </a>
              <span className="mx-1">·</span>
            </li>
          </>
        )}
        {country && (
          <>
            <li>
              <a href="#" className="hover:underline">
                {country}
              </a>
              <span className="mx-1">·</span>
            </li>
          </>
        )}
        {town && (
          <>
            <li>
              <a href="#" className="hover:underline">
                {town}
              </a>
              <span className="mx-1">·</span>
            </li>
          </>
        )}
        <li className="font-bold">{name}</li>
      </ol>
    </nav>
  );
};

export default Breadcrumb; // ✅ ensures it's a module
